export default __webpack_public_path__ + "static/media/i3500.4270eda5.jpg";